import type { PermissionPayload } from '@Application/Security/Roles/Actions/userPermissionsFetched';

// A leading `readonly` here would make the payload a `ReadonlyArray`, not assignable to synapse's
// `DefaultPayload.payload: Array<Record<string, unknown>>` constraint.
export type PermissionCatalogFetchedPayload = PermissionPayload[];

export type PermissionCatalogFetchedAction = {
	type: 'PERMISSION_CATALOG_FETCHED';
	payload: PermissionCatalogFetchedPayload;
};

export default (payload: PermissionCatalogFetchedPayload): PermissionCatalogFetchedAction => ({
	type: 'PERMISSION_CATALOG_FETCHED',
	payload,
});
